<script lang="ts" setup>
import type { NavLink } from '#core/types'

defineProps<{
  items: NavLink[]
}>()
</script>

<template>
  <nav>
    <ul class="space-y-1">
      <li v-for="item in items" :key="item.to">
        <NuxtLink
          :to="item.to"
          class="flex h-8 w-full items-center gap-2 rounded-lg p-2 text-secondary transition hover:bg-neutral-600/30"
          exact-active-class="bg-neutral-600/30"
        >
          <div class="grow text-left">
            {{ item.label }}
          </div>
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>
